import React from 'react';
import { styled } from '@mui/material/styles';
import { maxWidth } from '../../sharedStyles/layoutStyles';

/**
 *
 * @param {React.ReactNode} children
 * @param {String | React.FC} [component]
 *
 * @returns {React.ReactElement}
 */

const DS_MaxWidthLayout = ({ children }) => {
  return <StyledMaxWidthWrapper>{children}</StyledMaxWidthWrapper>;
};

export default DS_MaxWidthLayout;

const StyledMaxWidthWrapper = styled('div')(
  () => `
   position: relative;
   ${maxWidth}
`,
);
